import { SwivuSortedGroupersMixin } from "./mixins/SwivuSortedGroupersMixin";
import { SwivuStoreArchiveMixin } from "./mixins/SwivuStoreArchiveMixin";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";
import { Store } from "@bryntum/schedulerpro";
import { SpotIncentive } from "../models/SpotIncentive.jsx";

export class SwivuSpotIncentiveStore extends SwivuSortedGroupersMixin(SwivuStoreArchiveMixin(Store)) {
  static get $name() {
    return "SwivuSpotIncentiveStore";
  }

  static get configurable() {
    return {
      modelClass: SpotIncentive,
      id: STORE_KEYS.spotIncentiveStore,
      storeId: STORE_KEYS.spotIncentiveStore
    };
  }
}